import { Component, ChangeDetectorRef } from '@angular/core'
import { IonicPage, NavController, NavParams, LoadingController, ToastController, Loading } from 'ionic-angular'

import { AuthProvider } from '../../providers/auth/auth'
import { HousingUnitProvider } from '../../providers/housing-unit/housing-unit'
import { CondominiumProvider } from '../../providers/condominium/condominium'

import { HousingUnit, } from '../../models/models'
import { ControlPanelPage } from '../control-panel/control-panel'
@IonicPage()
@Component({
	selector: 'page-housing-unit-edit',
	templateUrl: 'housing-unit-edit.html',
})
export class HousingUnitEditPage {
	public housingUnit: HousingUnit

	public get isAdministrator() {
		if(!this.housingUnit.condominium) {
			console.error('Unità abitativa senza condominio caricato', this.housingUnit)
			return false
		}

		return this.auth.hasCondominiumRole(this.housingUnit.condominium, 'is_administrator')
	}

	public goToControlPanel() {
		this.navCtrl.setRoot(ControlPanelPage)
	}
	public isLoading: boolean = true;

	public get isResident() {
		return this.auth.hasHousingUnitRole(this.housingUnit, 'is_resident')
	}

	public get isSuperuser() {
		return this.auth.hasRole(['is_admin', 'is_operator'])
	}

	public loading: Loading

	constructor(
		private changeDetector: ChangeDetectorRef,
		public navCtrl: NavController,
		public navParams: NavParams,
		public auth: AuthProvider,
		public condominiums: CondominiumProvider,
		public housingUnits: HousingUnitProvider,
		public loadingCtrl: LoadingController,
		public toastCtrl: ToastController
	) {
		this.housingUnit = navParams.get('housingUnit')
	}

	public save() {
		let self = this
		this.loading = this.loadingCtrl.create({
			content: 'Salvataggio in corso...',
			dismissOnPageChange: false
		})
		this.loading.present()
		this.housingUnits.update(this.housingUnit).then(
			(_housingUnit: HousingUnit) => {
				self.loading.dismiss()
				let toast = this.toastCtrl.create({
					message: 'Unità abitativa "' + this.housingUnit.label + " - " + this.housingUnit.internal + '" aggiornata',
					position: 'middle',
					duration: 3000,
					cssClass: "light"
				})
				toast.present()
				self.navCtrl.pop()
			}).catch((e: any) => {
				console.error('Errore aggiornando l\'unità abitativa', e)
				self.loading.dismiss()
				let toast = this.toastCtrl.create({
					message: 'Errore aggiornando l\'unità abitativa',
					position: 'middle',
					duration: 3000,
					cssClass: "danger"
				})
				toast.present()
			})
	}
	ionViewWillEnter() {
		this.refresh()
	}

	refresh() {
		let self = this

		//this.isLoading=true;
		this.isLoading = true
		this.housingUnits.getById(this.housingUnit.id, [
			'intercomUser',
			'condominium.address',
			'condominium.userRoles',
			'residents',
			//'userRoles',
		]).then((housingUnit: HousingUnit) => {
			self.housingUnit = housingUnit
			console.debug('[HousingUnitEditPage.refresh()] Unità abitativa da modificare:', housingUnit)
			//self.isLoading = false;
			self.isLoading = false
			self.changeDetector.detectChanges()
		}).catch(error => {
			self.isLoading = false
			self.changeDetector.detectChanges()
			//self.isLoading = false;
			console.error("Errore recuperando l\'unità abitativa:", error)
			let toast = this.toastCtrl.create({
				message: 'Errore recuperando l\'unità abitativa',
				position: 'middle',
				duration: 3000,
				cssClass: "danger"
			})
			toast.present()
		})
	}
}



// WEBPACK FOOTER //
// ./src/pages/housing-unit-edit/housing-unit-edit.ts